module.exports = __webpack_public_path__ + "img/clock.10bb69e6.svg";